const puralise = (singular: string, pural: string, total: number) => {
  if (total === 1) {
    return singular;
  }

  return pural;
};

export default puralise;
